import { useEffect, useState } from "react";
import "./ProductoAgregado.scss";
import { Button, CloseButton } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

export default function ProductoAgregado() {
  const [producto, setProducto] = useState(null);
  const [showBanner, setShowBanner] = useState(true);
  const [closeMessage, setCloseMessage] = useState(false)
  const navigate = useNavigate()

  useEffect(() => {
    let lastScroll = 0;

    const handleScroll = () => {
      const currentScroll = window.scrollY;
      const windowHeight = window.innerHeight;
      const midpoint = windowHeight / 2;

      if (currentScroll < 600) {
        setShowBanner(true);
      } else {
        setShowBanner(false);
      }

      lastScroll = currentScroll;
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  },[])

  useEffect(() => {
    const prod = JSON.parse(localStorage.getItem('productoAgregado'));
    setProducto(prod);
    if (prod) {
      setCloseMessage(true)
    }
  }, [localStorage.getItem('productoAgregado')]);

  const handleCart = () => {
    localStorage.removeItem('productoAgregado');
    navigate('/carrito');
  };

  const handleCheckout = () => {
    localStorage.removeItem('productoAgregado');
    navigate('/checkout');
  };

  const handleClose = () => {
    localStorage.removeItem('productoAgregado');
    setProducto(null);
  }

  useEffect(()=>{
    if (closeMessage) {
      setTimeout(() => {
        handleClose();
        setCloseMessage(false)
      }, 5000); 
    }
  }, [closeMessage]) /**/

  return (
    <>
    {
      producto ?
        <div className={`wide-product-back `}>
          <CloseButton onClick={handleClose} variant="white"/>{/*  ${!showBanner ? 'translate-y-full z-0' : ''} */}
          <div className="product-added">
            <div className="added-div">
              <div className="added-img">
                <img loading="lazy" src={producto.img} alt="imagen producto agregado" />
              </div>
              <div className="added-info">
                <span>Agregado al carrito</span>
                <span>{producto.nombre}</span>
              </div>
            </div>
            <div className="added-button btn-content">
              <Button variant="primary" className="small" onClick={handleCart}>Ver carrito</Button>
              <Button variant="third" className="small" onClick={handleCheckout}>Seguir con tu Pedido</Button>
            </div>
        </div>
      </div>
    :  null
    }
    </>
  )
}